// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { API_URL } from '../services/api';
// import { useNavigate } from 'react-router-dom';

// const AccountSettings = () => {
//   const [email, setEmail] = useState('');
//   const [inputEmail, setInputEmail] = useState('');
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [message, setMessage] = useState({ text: '', type: '' });
//   const [loading, setLoading] = useState(true);
//   const [showEmailModal, setShowEmailModal] = useState(false);
//   const [showNameModal, setShowNameModal] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const navigate = useNavigate();

//   const token = localStorage.getItem('access_token');

//   useEffect(() => {
//     if (!token) {
//       navigate('/login', { state: { message: 'Please login to access account settings' } });
//       return;
//     }
//     fetchUserDetails();
//   }, [token, navigate]);

//   // Auto-hide notifications after 4 seconds
//   useEffect(() => {
//     if (message.text) {
//       const timer = setTimeout(() => {
//         setMessage({ text: '', type: '' });
//       }, 4000);
//       return () => clearTimeout(timer);
//     }
//   }, [message]);

//   const fetchUserDetails = async () => {
//     setLoading(true);
//     try {
//       const [nameRes, emailRes] = await Promise.all([
//         axios.get(`${API_URL}update-name/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         }),
//         axios.get(`${API_URL}update-email/`, {
//           headers: { Authorization: `Bearer ${token}` },
//         }),
//       ]);

//       setFirstName(nameRes.data.first_name || '');
//       setLastName(nameRes.data.last_name || '');
//       setEmail(emailRes.data.email || '');
//       setInputEmail(emailRes.data.email || '');
//     } catch (err) {
//       console.error('Failed to fetch user details:', err);
//       handleApiError(err, 'Failed to load account details.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleApiError = (err, defaultMessage) => {
//     if (err.response) {
//       // Check for 401 Unauthorized
//       if (err.response.status === 401) {
//         localStorage.removeItem('access_token');
//         navigate('/login', { state: { message: 'Session expired. Please login again.' } });
//         return;
//       }
//       // Display server error message if available
//       setMessage({
//         text: err.response.data?.message || err.response.data?.error || defaultMessage,
//         type: 'error'
//       });
//     } else {
//       setMessage({ text: defaultMessage, type: 'error' });
//     }
//   };

//   const handleUpdateEmail = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage({ text: '', type: '' });
//     try {
//       await axios.patch(
//         `${API_URL}update-email/`,
//         { email: inputEmail },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );
//       setEmail(inputEmail);
//       setMessage({ text: 'Email updated successfully!', type: 'success' });
//       setShowEmailModal(false);
//     } catch (err) {
//       console.error('Error updating email:', err);
//       handleApiError(err, 'Failed to update email.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleUpdateName = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setMessage({ text: '', type: '' });
//     try {
//       await axios.put(
//         `${API_URL}update-name/`,
//         {
//           first_name: firstName,
//           last_name: lastName,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );
//       setMessage({ text: 'Name updated successfully!', type: 'success' });
//       setShowNameModal(false);
//     } catch (err) {
//       console.error('Error updating name:', err);
//       handleApiError(err, 'Failed to update name.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDeleteAccount = async () => {
//     try {
//       await axios.delete(`${API_URL}delete-account/`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       localStorage.removeItem('access_token');
//       navigate('/', { state: { message: 'Account deleted successfully' } });
//     } catch (err) {
//       console.error('Error deleting account:', err);
//       handleApiError(err, 'Failed to delete account.');
//       setShowDeleteConfirm(false);
//     }
//   };

//   if (loading && !firstName && !lastName && !email) {
//     return (
//       <div className="flex justify-center items-center min-h-[60vh]">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-400"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-sm">
//       <div className="border-b border-gray-200 pb-4 mb-6">
//         <h1 className="text-2xl font-semibold text-gray-800">Account Settings</h1>
//         <p className="text-sm text-gray-500 mt-1">Manage your personal information and account preferences</p>
//       </div>

//       {/* Notification */}
//       {message.text && (
//         <div className={`mb-6 p-3 rounded-md ${
//           message.type === 'success' ? 'bg-green-50 text-green-700 border border-green-100' : 'bg-red-50 text-red-700 border border-red-100'
//         }`}>
//           <p className="text-sm flex items-center">
//             {message.type === 'success' ? (
//               <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//               </svg>
//             ) : (
//               <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
//               </svg>
//             )}
//             {message.text}
//           </p>
//         </div>
//       )}

//       <div className="space-y-6">
//         {/* Personal Information Section */}
//         <section>
//           <h2 className="text-lg font-medium text-gray-700 mb-4">Personal Information</h2>

//           <div className="bg-gray-50 rounded-lg p-5">
//             <div className="flex flex-col md:flex-row justify-between md:items-center border-b border-gray-200 pb-4 mb-4">
//               <div className="mb-3 md:mb-0">
//                 <p className="text-sm font-medium text-gray-500">Name</p>
//                 <p className="text-base text-gray-800">{firstName} {lastName}</p>
//               </div>
//               <button
//                 onClick={() => setShowNameModal(true)}
//                 className="btn-edit"
//               >
//                 Edit Name
//               </button>
//             </div>

//             <div className="flex flex-col md:flex-row justify-between md:items-center">
//               <div>
//                 <p className="text-sm font-medium text-gray-500">Email Address</p>
//                 <p className="text-base text-gray-800">{email}</p>
//               </div>
//               <button
//                 onClick={() => setShowEmailModal(true)}
//                 className="btn-edit mt-3 md:mt-0"
//               >
//                 Edit Email
//               </button>
//             </div>
//           </div>
//         </section>

//         {/* Account Management Section */}
//         <section>
//           <h2 className="text-lg font-medium text-gray-700 mb-4">Account Management</h2>

//           <div className="bg-gray-50 rounded-lg p-5">
//             <div className="text-center sm:text-left">
//               <p className="text-sm text-gray-500 mb-4">
//                 If you no longer wish to use our service, you can delete your account permanently.
//                 Please note that this action cannot be undone.
//               </p>
//               <button
//                 onClick={() => setShowDeleteConfirm(true)}
//                 className="btn-danger"
//               >
//                 Delete Account
//               </button>
//             </div>
//           </div>
//         </section>
//       </div>

//       {/* Modals */}
//       {showEmailModal && (
//         <Modal title="Update Email Address" onClose={() => setShowEmailModal(false)} onSubmit={handleUpdateEmail} loading={loading}>
//           <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
//             New Email Address
//           </label>
//           <input
//             id="email"
//             type="email"
//             value={inputEmail}
//             onChange={(e) => setInputEmail(e.target.value)}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500"
//             required
//           />
//         </Modal>
//       )}

//       {showNameModal && (
//         <Modal title="Update Name" onClose={() => setShowNameModal(false)} onSubmit={handleUpdateName} loading={loading}>
//           <div className="space-y-3">
//             <div>
//               <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
//                 First Name
//               </label>
//               <input
//                 id="firstName"
//                 type="text"
//                 placeholder="First Name"
//                 value={firstName}
//                 onChange={(e) => setFirstName(e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500"
//                 required
//               />
//             </div>
//             <div>
//               <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
//                 Last Name
//               </label>
//               <input
//                 id="lastName"
//                 type="text"
//                 placeholder="Last Name"
//                 value={lastName}
//                 onChange={(e) => setLastName(e.target.value)}
//                 className="w-full p-2 border border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500"
//                 required
//               />
//             </div>
//           </div>
//         </Modal>
//       )}

//       {showDeleteConfirm && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
//           <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//             <div className="text-center mb-5">
//               <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
//                 <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
//                 </svg>
//               </div>
//               <h3 className="text-lg font-medium text-gray-900 mb-2">Delete Account</h3>
//               <p className="text-sm text-gray-600">
//                 Are you sure you want to delete your account? This action cannot be undone and all your data will be permanently removed.
//               </p>
//             </div>
//             <div className="flex justify-center gap-3 mt-6">
//               <button
//                 onClick={() => setShowDeleteConfirm(false)}
//                 className="btn-secondary"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleDeleteAccount}
//                 className="btn-danger"
//               >
//                 Delete Account
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* CSS for Buttons */}
//       <style jsx>{`
//         .btn-edit {
//           display: inline-flex;
//           align-items: center;
//           padding: 0.5rem 1rem;
//           border-radius: 0.375rem;
//           font-size: 0.875rem;
//           font-weight: 500;
//           color: #4b5563;
//           background-color: #ffffff;
//           border: 1px solid #d1d5db;
//           box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
//           transition: all 0.15s ease;
//         }

//         .btn-edit:hover {
//           color: #4b5563;
//           background-color: #f9fafb;
//           border-color: #9ca3af;
//         }

//         .btn-edit:before {
//           content: '';
//           display: inline-block;
//           background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234b5563'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z'%3E%3C/path%3E%3C/svg%3E");
//           width: 1rem;
//           height: 1rem;
//           margin-right: 0.5rem;
//         }

//         .btn-danger {
//           display: inline-flex;
//           align-items: center;
//           padding: 0.5rem 1rem;
//           border-radius: 0.375rem;
//           font-size: 0.875rem;
//           font-weight: 500;
//           color: #991b1b;
//           background-color: #ffffff;
//           border: 1px solid #fee2e2;
//           box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
//           transition: all 0.15s ease;
//         }

//         .btn-danger:hover {
//           color: #ffffff;
//           background-color: #ef4444;
//           border-color: #ef4444;
//         }

//         .btn-danger:before {
//           content: '';
//           display: inline-block;
//           background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'%3E%3C/path%3E%3C/svg%3E");
//           width: 1rem;
//           height: 1rem;
//           margin-right: 0.5rem;
//         }

//         .btn-primary {
//           display: inline-flex;
//           align-items: center;
//           padding: 0.5rem 1rem;
//           border-radius: 0.375rem;
//           font-size: 0.875rem;
//           font-weight: 500;
//           color: #ffffff;
//           background-color: #3b82f6;
//           border: 1px solid #3b82f6;
//           box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
//           transition: all 0.15s ease;
//         }

//         .btn-primary:hover {
//           background-color: #2563eb;
//           border-color: #2563eb;
//         }

//         .btn-secondary {
//           display: inline-flex;
//           align-items: center;
//           padding: 0.5rem 1rem;
//           border-radius: 0.375rem;
//           font-size: 0.875rem;
//           font-weight: 500;
//           color: #4b5563;
//           background-color: #ffffff;
//           border: 1px solid #d1d5db;
//           box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
//           transition: all 0.15s ease;
//         }

//         .btn-secondary:hover {
//           background-color: #f3f4f6;
//           border-color: #9ca3af;
//         }

//         button:disabled {
//           opacity: 0.5;
//           cursor: not-allowed;
//         }
//       `}</style>
//     </div>
//   );
// };

// const Modal = ({ title, children, onClose, onSubmit, loading }) => (
//   <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
//     <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//       <h3 className="text-lg font-medium text-gray-900 mb-4 border-b border-gray-200 pb-2">{title}</h3>
//       <form onSubmit={onSubmit} className="space-y-4">
//         {children}
//         <div className="flex justify-end gap-3 mt-6">
//           <button
//             type="button"
//             onClick={onClose}
//             className="btn-secondary"
//           >
//             Cancel
//           </button>
//           <button
//             type="submit"
//             disabled={loading}
//             className="btn-primary"
//           >
//             {loading ? (
//               <span className="flex items-center justify-center">
//                 <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                 </svg>
//                 Saving...
//               </span>
//             ) : (
//               'Save Changes'
//             )}
//           </button>
//         </div>
//       </form>
//     </div>
//   </div>
// );

// export default AccountSettings;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../services/api";
import { useNavigate } from "react-router-dom";
import "./AccountSetting.css";
import shrokImg from "./shrok.svg";

const AccountSettings = () => {
  const [email, setEmail] = useState("");
  const [inputEmail, setInputEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(true);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showNameModal, setShowNameModal] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const navigate = useNavigate();

  const token = localStorage.getItem("access_token");

  useEffect(() => {
    if (!token) {
      navigate("/login", {
        state: { message: "Please login to access account settings" },
      });
      return;
    }
    fetchUserDetails();
  }, [token, navigate]);

  // Auto-hide notifications after 4 seconds
  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ text: "", type: "" });
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const fetchUserDetails = async () => {
    setLoading(true);
    try {
      const [nameRes, emailRes] = await Promise.all([
        axios.get(`${API_URL}update-name/`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${API_URL}update-email/`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      setFirstName(nameRes.data.first_name || "");
      setLastName(nameRes.data.last_name || "");
      setEmail(emailRes.data.email || "");
      setInputEmail(emailRes.data.email || "");
    } catch (err) {
      console.error("Failed to fetch user details:", err);
      handleApiError(err, "Failed to load account details.");
    } finally {
      setLoading(false);
    }
  };

  const handleApiError = (err, defaultMessage) => {
    if (err.response) {
      // Check for 401 Unauthorized
      if (err.response.status === 401) {
        localStorage.removeItem("access_token");
        navigate("/login", {
          state: { message: "Session expired. Please login again." },
        });
        return;
      }
      // Display server error message if available
      setMessage({
        text:
          err.response.data?.message ||
          err.response.data?.error ||
          defaultMessage,
        type: "error",
      });
    } else {
      setMessage({ text: defaultMessage, type: "error" });
    }
  };

  const handleUpdateEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: "", type: "" });
    try {
      await axios.patch(
        `${API_URL}update-email/`,
        { email: inputEmail },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setEmail(inputEmail);
      setMessage({ text: "Email updated successfully!", type: "success" });
      setShowEmailModal(false);
    } catch (err) {
      console.error("Error updating email:", err);
      handleApiError(err, "Failed to update email.");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateName = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: "", type: "" });
    try {
      await axios.put(
        `${API_URL}update-name/`,
        {
          first_name: firstName,
          last_name: lastName,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setMessage({ text: "Name updated successfully!", type: "success" });
      setShowNameModal(false);
    } catch (err) {
      console.error("Error updating name:", err);
      handleApiError(err, "Failed to update name.");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAccount = async () => {
    try {
      await axios.delete(`${API_URL}delete-account/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      localStorage.removeItem("access_token");
      navigate("/", { state: { message: "Account deleted successfully" } });
    } catch (err) {
      console.error("Error deleting account:", err);
      handleApiError(err, "Failed to delete account.");
      setShowDeleteConfirm(false);
    }
  };

  if (loading && !firstName && !lastName && !email) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-400"></div>
      </div>
    );
  }

  return (
    <div className="accountSetting">
      <div className="ASshrokImg">
        <img src={shrokImg}></img>
      </div>
      <div className="ASright max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-sm">
        <div className="ASaccountSetting border-b border-gray-200 pb-4 mb-6 text-center">
          <h1 className="text-2xl font-semibold text-gray-800">
            Account Settings
          </h1>
          <p className="text-sm text-gray-500 mt-1">
            Manage your personal information and account preferences
          </p>
        </div>

        {/* Notification */}
        {message.text && (
          <div
            className={`mb-6 p-3 rounded-md text-center ${
              message.type === "success"
                ? "bg-green-50 text-green-700 border border-green-100"
                : "bg-red-50 text-red-700 border border-red-100"
            }`}
          >
            <p className="text-sm flex items-center justify-center">
              {message.type === "success" ? (
                <svg
                  className="w-3 h-3 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                    clipRule="evenodd"
                  />
                </svg>
              ) : (
                <svg
                  className="w-3 h-3 mr-2"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              )}
              {message.text}
            </p>
          </div>
        )}

        <div className="ASpersonalInfo space-y-6">
          {/* Personal Information Section */}
          <div>
            <h2 className="text-lg font-medium text-gray-700 mb-4 text-center">
              Personal Information
            </h2>

            <div className="ASnameEmail bg-gray-50 rounded-lg p-5">
              <div className="ASname flex flex-col md:flex-row justify-between md:items-center border-b border-gray-200 pb-4 mb-4">
                <div className="mb-3 md:mb-0 text-center md:text-left">
                  <p className="ASsub text-sm font-medium text-gray-500">
                    Name :
                  </p>
                  <p className="text-base text-gray-800">
                    {firstName} {lastName}
                  </p>
                </div>
                <div className="ASbutton text-center md:text-left">
                  <button
                    onClick={() => setShowNameModal(true)}
                    className="btn-edit"
                  >
                    Edit Name
                  </button>
                </div>
              </div>

              <div className="ASemail flex flex-col md:flex-row justify-between md:items-center">
                <div className="text-center md:text-left">
                  <p className="ASsub text-sm font-medium text-gray-500">
                    Email Address :
                  </p>
                  <p className="text-base text-gray-800">{email}</p>
                </div>
                <div className="ASbutton text-center md:text-left mt-3 md:mt-0">
                  <button
                    onClick={() => setShowEmailModal(true)}
                    className="btn-edit"
                  >
                    Edit Email
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Account Management Section */}
          <section>
            <h2 className="text-lg font-medium text-gray-700 mb-4 text-center">
              Account Management
            </h2>

            <div className="bg-gray-50 rounded-lg p-5">
              <div className="text-center">
                <p className="text-sm text-gray-500 mb-4">
                  If you no longer wish to use our service, you can delete your
                  account permanently. Please note that this action cannot be
                  undone.
                </p>
                <div className="ASbutton">
                  <button
                    onClick={() => setShowDeleteConfirm(true)}
                    className="btn-danger"
                  >
                    Delete Account
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Modals */}
        {showEmailModal && (
          <Modal
            title="Update Email Address"
            onClose={() => setShowEmailModal(false)}
            onSubmit={handleUpdateEmail}
            loading={loading}
          >
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700 mb-1 text-center"
            >
              New Email Address
            </label>
            <input
              id="email"
              type="email"
              value={inputEmail}
              onChange={(e) => setInputEmail(e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500"
              required
            />
          </Modal>
        )}

        {showNameModal && (
          <Modal
            title="Update Name"
            onClose={() => setShowNameModal(false)}
            onSubmit={handleUpdateName}
            loading={loading}
          >
            <div className="space-y-3">
              <div>
                <label
                  htmlFor="firstName"
                  className="block text-sm font-medium text-gray-700 mb-1 text-center"
                >
                  First Name
                </label>
                <input
                  id="firstName"
                  type="text"
                  placeholder="First Name"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="lastName"
                  className="block text-sm font-medium text-gray-700 mb-1 text-center"
                >
                  Last Name
                </label>
                <input
                  id="lastName"
                  type="text"
                  placeholder="Last Name"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:ring-green-500 focus:border-green-500"
                  required
                />
              </div>
            </div>
          </Modal>
        )}

        {showDeleteConfirm && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
              <div className="text-center mb-5">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                  <svg
                    className="h-5 w-5 text-red-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Delete Account
                </h3>
                <p className="text-sm text-gray-600">
                  Are you sure you want to delete your account? This action
                  cannot be undone and all your data will be permanently
                  removed.
                </p>
              </div>
              <div className="flex justify-center gap-3 mt-6">
                <button
                  onClick={() => setShowDeleteConfirm(false)}
                  className="btn-secondary"
                >
                  Cancel
                </button>
                <button onClick={handleDeleteAccount} className="btn-danger">
                  Delete Account
                </button>
              </div>
            </div>
          </div>
        )}

        {/* CSS for Buttons */}
        <style jsx>{`
          .btn-edit {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            font-size: 0.875rem;
            font-weight: 500;
            color: #4b5563;
            background-color: #ffffff;
            border: 1px solid #d1d5db;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            transition: all 0.15s ease;
          }

          .btn-edit:hover {
            color: #4b5563;
            background-color: #f9fafb;
            border-color: #9ca3af;
          }

          .btn-edit:before {
            content: "";
            display: inline-block;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234b5563'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z'%3E%3C/path%3E%3C/svg%3E");
            width: 0.875rem;
            height: 0.875rem;
            margin-right: 0.5rem;
          }

          .btn-danger {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            font-size: 0.875rem;
            font-weight: 500;
            color: #991b1b;
            background-color: #ffffff;
            border: 1px solid #fee2e2;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            transition: all 0.15s ease;
          }

          .btn-danger:hover {
            color: #ffffff;
            background-color: #ef4444;
            border-color: #ef4444;
          }

          .btn-danger:before {
            content: "";
            display: inline-block;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'%3E%3C/path%3E%3C/svg%3E");
            width: 0.875rem;
            height: 0.875rem;
            margin-right: 0.5rem;
          }

          .btn-primary {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            font-size: 0.875rem;
            font-weight: 500;
            color: #ffffff;
            background-color: #3b82f6;
            border: 1px solid #3b82f6;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            transition: all 0.15s ease;
          }

          .btn-primary:hover {
            background-color: #2563eb;
            border-color: #2563eb;
          }

          .btn-secondary {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            font-size: 0.875rem;
            font-weight: 500;
            color: #4b5563;
            background-color: #ffffff;
            border: 1px solid #d1d5db;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            transition: all 0.15s ease;
          }

          .btn-secondary:hover {
            background-color: #f3f4f6;
            border-color: #9ca3af;
          }

          button:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        `}</style>
      </div>
    </div>
  );
};

const Modal = ({ title, children, onClose, onSubmit, loading }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
      <h3 className="text-lg font-medium text-gray-900 mb-4 border-b border-gray-200 pb-2 text-center">
        {title}
      </h3>
      <form onSubmit={onSubmit} className="space-y-4">
        {children}
        <div className="ASbuttonSub flex justify-center gap-3 mt-6">
          <button type="button" onClick={onClose} className="btn-secondary">
            Cancel
          </button>
          <button type="submit" disabled={loading} className="btn-primary">
            {loading ? (
              <span className="flex items-center justify-center">
                <svg
                  className="animate-spin -ml-1 mr-2 h-3 w-3 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Saving...
              </span>
            ) : (
              "Save Changes"
            )}
          </button>
        </div>
      </form>
    </div>
  </div>
);

export default AccountSettings;
